import React from 'react';

import { SHOPEE_AFFILIATE_CHANNEL_TYPE } from './constants';

const ShopeeAffiliateAddPage = React.lazy(() =>
  import('./pages/add').then((module) => ({ default: module.ShopeeAffiliateAddPage }))
);

const ShopeeAffiliateEditPage = React.lazy(() =>
  import('./pages/edit').then((module) => ({ default: module.ShopeeAffiliateEditPage }))
);

const ShopeeAffiliateTemplate = React.lazy(() =>
  import('./templates').then((module) => ({ default: module.ShopeeAffiliateTemplate }))
);

/**
 * `:channelId` is the grant's id, not a sale channel's: the list links a grant here under the same
 * param name the sale channels use, so `IntegrationRoutePath().salesChannel().details()` builds it.
 */
export const shopeeAffiliateRouting = [
  {
    path: SHOPEE_AFFILIATE_CHANNEL_TYPE,
    element: <ShopeeAffiliateTemplate />,
    children: [
      {
        index: true,
        element: <ShopeeAffiliateAddPage />,
      },
      {
        path: ':channelId',
        element: <ShopeeAffiliateEditPage />,
      },
    ],
  },
];
